export enum ApiType {
  TaxList = "TaxList",
  BasicInfo = "BasicInfo",
}
